/* Brand template — scroll-snap carousel used by brand-testimonials. */
class BrandCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    if (!this.track) return;

    this.dots = this.querySelector('[data-carousel-dots]');

    this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.page(-1));
    this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.page(1));

    if (!this.dots) return;
    this.buildDots();
    this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
    // The column count is responsive, so the number of pages changes with the viewport.
    new ResizeObserver(() => this.buildDots()).observe(this.track);
  }

  get pageCount() {
    if (!this.track.clientWidth) return 1;
    return Math.max(1, Math.round(this.track.scrollWidth / this.track.clientWidth));
  }

  get currentPage() {
    if (!this.track.clientWidth) return 0;
    return Math.round(this.track.scrollLeft / this.track.clientWidth);
  }

  buildDots() {
    const count = this.pageCount;
    if (this.dots.childElementCount !== count) {
      this.dots.replaceChildren(
        ...Array.from({ length: count }, (_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'brand-dots__dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${count}`);
          dot.addEventListener('click', () => {
            this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
          });
          return dot;
        })
      );
    }
    this.dots.hidden = count < 2;
    this.syncDots();
  }

  syncDots() {
    const active = this.currentPage;
    Array.from(this.dots.children).forEach((dot, i) => {
      dot.setAttribute('aria-current', i === active);
    });
  }

  page(direction) {
    // One "page" is whatever is currently visible, so this tracks the responsive column count.
    this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
  }
}

if (!customElements.get('brand-carousel')) {
  customElements.define('brand-carousel', BrandCarousel);
}
